import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { Article } from '@mui/icons-material';
import useGetAvatar from '@/hooks/useGetAvatar';

interface Props {
    lat: number;
    lng: number;
    avatarUriId: string;
    onClick?: () => void;
}

const CustomMarker = ({ avatarUriId, onClick }: Props) => {
    const { avatar, isLoading } = useGetAvatar({ avatarUriId });

    if (isLoading) return <></>;
    return (
        <div id={avatar?.id}>
            <Box
                id={'marker_' + avatar?.id}
                onClick={(e) => {
                    e.stopPropagation();
                    onClick?.();
                }}
            >
                <Tooltip title={avatar?.name}>
                    <Article
                        fontSize={'large'}
                        sx={{
                            ':hover': {
                                transform: 'scale3d(1.2, 1.2, 1)',
                                cursor: 'pointer',
                                transition: 'transform 0.15s ease-in-out',
                            },
                        }}
                        color={'error'}
                    />
                </Tooltip>
            </Box>
        </div>
    );
};

export default CustomMarker;
